<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.expensetypes') }}
      </BaseTopBarContent>
      <BaseTopBarContent
        v-if="hasRoleEdit"
        className="right"
      >
        <div class="action">
          <BaseButton @click="openModalType">
            {{ $t('apps.expenses.button.managetype') }}
          </BaseButton>
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <BaseTable
        :hidePagination="true"
        class="custom-table"
        tableClass="table-bordered"
      >
        <template #thead>
          <thead>
            <tr>
              <th>
                {{ $t('apps.expenses.message.expensetypes') }}
              </th>
              <th
                class="text-center"
                style="width: 150px;"
              >
                {{ $t('message.default') }}
              </th>
              <th
                class="text-center"
                style="width: 150px;"
              >
                {{ $t('message.status') }}
              </th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr
              v-for="(item, index) in expenseTypes"
              :key="index"
            >
              <td>
                {{ getMasterDataText(item.name, $t) }}
              </td>
              <td class="text-center">
                {{ item.is_default ? $t('message.yes') : '' }}
              </td>
              <td class="text-center">
                <div
                  v-if="item.is_active"
                  class="text-success"
                >
                  <i class="fas fa-check"/>
                  {{ $t('message.enabled') }}
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </BaseTable>

      <BaseModalCustomMasterData
        v-if="expenseTypes.length"
        :list="settings"
        :id="MODAL_TYPES"
        :headerText="$t('sidebar.expensetypes')"
        @onClose="handleCloseModalType"
        @onSubmit="handleSubmitModalType"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'
import { getMasterDataText } from '../../../../helpers'

export default {
  mixins: [userPermissionMixin],
  data () {
    return {
      MODAL_TYPES: 'MODAL_TYPES',
      getMasterDataText,
      loading: true,
      settings: [],
      original_settings: [],
    }
  },
  computed: {
    ...mapGetters({
      expenseSetting: 'getExpenseSetting',
    }),
    expenseTypes() {
      if (this.expenseSetting && this.expenseSetting.types) {
        return this.expenseSetting.types
      }
      return []
    },
    form () {
      return {
        settings: this.settings,
      }
    },
  },
  created () {
    this.fetchData()
  },
  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.expenses.title'),
      current: {
        app_name: 'expenses',
        app_id: 6,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
    })
  },
  methods: {
    ...mapActions([
      'updateSettingsExpense',
    ]),
    async fetchData () {
      await this.$store.dispatch('setLocalStorageShopInfo')
      this.loading = false

      this.settings = _.cloneDeep(this.expenseTypes)
      this.original_settings = _.cloneDeep(this.expenseTypes)
    },
    openModalType() {
      $(`#${this.MODAL_TYPES}`).modal('show')
    },
    handleCloseModalType() {
      this.types = _.cloneDeep(this.original_types)
      $(`#${this.MODAL_TYPES}`).modal('hide')
    },
    async handleSubmitModalType(payload) {
      this.settings = _.cloneDeep(payload)
      this.original_settings = _.cloneDeep(payload)
      const response = await this.updateSettingsExpense({
        types: payload,
      })
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
        this.showFinish(this.$Progress)
      }

      $(`#${this.MODAL_TYPES}`).modal('hide')
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/expenses/type/List.vue